import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { Avatar } from '@/app/models/interface/avatar.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class AvatarService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'avatar';

  create(id_usuario: number, archivo: File) {
    const data = {
      id_usuario,
    };
    const formData = new FormData();
    formData.append('file', archivo);
    formData.append('data', JSON.stringify(data));
    return this.http.post<CustomResponse<Avatar>>(this.url, formData).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }
}
